import React from 'react';
import ReleaseCard from './ReleaseCard';

export default function ReleaseV140({ createClickableListItem, createThumbnail }) {
  return (
    <ReleaseCard version="v1.4.0" date="29th June 2025" title="A fresh new look!">
      <p className="text-gray-300 mb-4">We thought it was time for a revamp and you guys deserve a more pleasing on-the-eye experience so we've spent a lot of time on a new stylish look and feel to the app!</p>
      <ul className="text-gray-400 space-y-2 mb-4">
        {createClickableListItem('Major frontend refresh, more stylish look for the main game screen', '/v1.4.0/newLayout.jpg')}
      </ul>
      <div className="mb-4">
        <p className="text-gray-300 mb-2 text-sm">This releases screenshots:</p>
        <div className="flex flex-wrap gap-4">
          {createThumbnail('/v1.4.0/newLayout.jpg', 'Major frontend refresh, more stylish look for the main game screen feature preview')}
        </div>
      </div>
      <p className="text-purple-400 font-medium">Take her for a spin and let us know what you think of the new look!</p>
    </ReleaseCard>
  );
}
